import { FC } from 'react';
import { useIntl } from 'react-intl';
import queryString from 'query-string';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { ExternalLink, FeatureFlagDisplay, Icon } from '@app/components';
import { useSearchContext } from '@app/contexts';
import { Feature } from '@app/constants';

const cnBem = createBemBlockBuilder(['searchResultsPage']);

export const getPassthroughLink = ({
  consortiaLink,
  query,
  option,
}: {
  consortiaLink: string;
  query: string;
  option: string;
}) => {
  const baseUrl = consortiaLink.endsWith('/')
    ? consortiaLink
    : `${consortiaLink}/`;
  const searchQuery = queryString.stringify({ query, option });

  return `${baseUrl}search?${searchQuery}`;
};

export const PassthroughLink: FC = () => {
  const { $t } = useIntl();
  const {
    state: { query },
    searchOption,
  } = useSearchContext();

  return (
    <FeatureFlagDisplay
      flagToMatch={{ name: Feature.passthroughlink }}
      renderOn={({ config: { consortiaName, consortiaLink = '' } }) => (
        <div
          className={cnBem('__passthrough-link')}
          data-auto="passthrough-link"
        >
          {$t(
            {
              id: 'searchResults.searchConsortia',
              defaultMessage:
                'Search for <i>"{term}"</i> across <a>{consortiaName}</a>',
            },
            {
              term: query,
              consortiaName,
              i: chunks => <i>{chunks}</i>,
              a: chunks => (
                <>
                  <ExternalLink
                    href={getPassthroughLink({
                      consortiaLink,
                      query,
                      option: searchOption,
                    })}
                  >
                    {chunks}
                  </ExternalLink>
                  <Icon icon={faExternalLink} />
                </>
              ),
            }
          )}
        </div>
      )}
    />
  );
};
